<template>
  <div class="result-container">
    <div class="header">
      <img
        class="logo-img"
        src="https://tx-res.supercarrier8.com/sup8-ui/2.0/sup8-h5-app-amison/logo.png"
      />
    </div>
    <div class="layout">
      <div v-html="replyContent"></div>
      <!-- 首查 -->
      <div class="buleColor" v-if="replyType === '300104'">
        <span class="underline" @click.stop="onAgain"
          >Need to verify other Product?</span
        >
      </div>
      <!-- 复查 -->
      <div class="buleColor" v-else-if="replyType === '300105'">
        <span class="underline" @click.stop="onAgain"
          >Want to verification Again?</span
        >
      </div>
      <!-- 超期、超次、数码不存在、未激活等异常 -->
      <div class="buleColor" v-else>
        <span class="underline" @click.stop="onAgain"
          >Do the verification again?</span
        >
      </div>

      <!-- <div class="remark-box">
            <div style="margin-bottom: 5px">Take <span class="font-weight">20% off</span> your next order!</div>
            <div>Use Code at <span class="font-weight">CHECKOUT</span></div>
            <div class="input-code">
                <span class="input-left">ATCODE20</span>
                <span class="input-right" @click.stop="copyCode">Copy Code</span>
            </div>
        </div> -->
      <div class="verify-btn" @click.stop="JumpTo">Shop Now</div>
    </div>
  </div>
</template>
  
  <script>
import api from "@/api";
import { mapGetters } from "vuex";
let getters = {
  code: "code",
  lang: "lang",
  platform: "platform",
  channelType: "channelType",
  wxUser: "wxUser",
  eNo: "eNo",
  gis: "gis",
  gpsType: "gpsType",
  childData: "childData",
  needGis: "needGis", // 当前模板是否需要获取地理位置
};
const GUID = function () {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
};
export default {
  name: "Result",
  data() {
    return {
      antiFakeInfoDetail: {},
      eventId: "",
      replyType: "",
      replyContent: "",
      num: 0,
    };
  },
  computed: mapGetters(getters),
  watch: {
    num: {
      handler(value) {
        if (value === 2) {
          console.log("执行吧", this.eventId);
          console.log("locationChannel", this.locationChannel);
          console.log("eventId", this.eventId);
          this.getAntiInfo();
        }
      },
      deep: true,
    },
  },
  created(options) {
    if (this.$route.query.code) {
      this.$toast.loading({
        message: "loading...",
        mask: true,
      });
      this.$store.dispatch("getLocation").then((location) => {
        this.locationChannel = location.channel;
        this.num++;
      });
      console.log(this.$route.query);
      this.getAntifake(
        this.$route.query.code,
        this.$route.query.userName,
        this.$route.query.email
      );
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRoute = from;
      // this.fromPath = from.path
      console.log("来自页面:", this, from.path);
    });
  },

  methods: {
    onAgain() {
      this.$router.push({
        path: "/",
      });
    },
    async copyCode() {
      const codeToCopy = "ATCODE20";

      try {
        // Use the Clipboard API if available
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(codeToCopy);
          this.$toast.success("Code copied to clipboard!");
        } else {
          // Fallback for older browsers
          this.fallbackCopyTextToClipboard(codeToCopy);
        }
      } catch (err) {
        console.error("Failed to copy: ", err);
        this.$toast.fail("Failed to copy code");
      }
    },

    // Fallback method for older browsers
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // Move textarea off-screen to prevent scrolling
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand("copy");
        if (successful) {
          this.$toast.success("Code copied to clipboard!");
        } else {
          this.$toast.fail("Failed to copy code");
        }
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
        this.$toast.fail("Failed to copy code");
      }

      document.body.removeChild(textArea);
    },
    JumpTo() {
      window.location.href = "https://www.amazingthing.com";
    },
    async getAntifake(code, userName, email) {
      const cacheGuid = localStorage.getItem("anitGuid") || GUID();
      localStorage.setItem("anitGuid", cacheGuid);
      let params = {
        channelType: this.channelType,
        code: code,
        requestId: cacheGuid,
        languageType: this.lang,
        enterpriseNo: this.eNo,
        fromInfo: "",
        toInfo: window.location.href,
        // toInfo: "https://testh5v2.yesno.com.cn/?6212434132265DF37FB",
        webBrowser: navigator.userAgent,
        asyncFromInfo: true,
        f1: userName,
        f2: email,
      };
      const res = await api.getAntifake(params);
      if (res.code === 200) {
        this.num++;
        this.eventId = res.data.eventId;
        this.replyContent = res.data.content;
        this.replyType = res.data.replyType;
      } else {
        this.$toast.fail(this.$t(res.code));
      }
    },
    async getAntiInfo() {
      const params = {
        enterpriseNo: this.eNo,
        eventId: this.eventId,
        fromInfo: this.locationChannel,
      };
      const res = await api.getAntiInfo(params);
    },
  },
};
</script>

  <style  lang="scss">
.result-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
  .layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%; // Full width on smaller screens
    padding: 22px;
    box-sizing: border-box;

    // When screen width exceeds 960px
    @media (min-width: 800px) {
      max-width: 760px; // Fixed width for larger screens
      margin: 0 auto; // Center the layout
      padding: 30px;
    }
  }
  .header {
    height: 100px;
    background: #000;
    padding-left: 25px;
    padding-top: 40px;
    box-sizing: border-box;
    @media (min-width: 800px) {
      padding-top: 35px;
    }
    .logo-img {
      width: 191px;
      height: auto;
      @media (min-width: 660px) {
        width: 230px;
      }
    }
  }
  .buleColor {
    color: #3992ff;
    font-size: 16px;
    text-align: center;
    padding: 10px 0 25px;
  }
  .underline {
    text-decoration: underline;
    cursor: pointer;
  }
  .remark-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #e8e8e8;
    border-radius: 8px;
    width: 340px;
    font-size: 18px;
    padding: 32px 0;
    @media (min-width: 800px) {
      width: 420px;
    }
    .font-weight {
      font-weight: bold;
    }
    .input-code {
      display: flex;
      border: 1px solid #d6d6d6;
      height: 50px;
      border-radius: 8px;
      text-align: center;
      line-height: 50px;
      overflow: hidden;
      width: 280px;
      margin-top: 20px;
      .input-left {
        background: #fff;
        flex: 1;
      }
      .input-right {
        background: #000;
        color: #00ab46;
        padding: 0 22px;
        font-size: 16px;
      }
    }
  }
  .verify-btn {
    width: 198px;
    height: 46px;
    line-height: 46px;
    border-radius: 23px;
    text-align: center;
    background: #000;
    margin: 40px auto 0;
    color: #fff;
    @media (min-width: 800px) {
      margin-top: 60px;
    }
  }
}
</style>
  